const log = {
    invalid_type: 'Typ dziennika jest nieprawidłowy.',
    invalid_time_window: '`end_time` musi być późniejsze niż `start_time`.',
};
export default Object.freeze(log);
